module.exports = __webpack_public_path__ + "img/icon3.b48f71a2.png";